/**
 * HemSyd Varukorg — oppnar den befintliga cart-modalen (samma innehall som
 * redan visas: fraktbar, radvara, "Rekommenderat for dig", "Varukorgen")
 * men triggat av klick istallet for hover pa desktop (#hsDesktopCartModal).
 * Mobilens oppna/stang-logik (#hemsydMobileCartModal, header-mobile.liquid)
 * rors inte - bara innehallet raknas om via samma hook (ajaxCart.afterCartLoad)
 * sa restructure/footer/rabattpris galler BADA modalerna automatiskt.
 *
 * restructure() bygger om modalen till flex-layout (header fast overst,
 * mittparti scrollar, footer fast underst) - SAMMA monster som redan
 * fungerar i Favoriter-panelen (.hsFavDrawer-list scrollar, header/footer
 * ligger utanfor). Kors en gang per modal (dataset-flagga).
 *
 * wrapFooter() flyttar ut .headerCartTotal + .headerCartButton (djupt
 * nastlade i det dynamiskt injicerade #cartContainer-innehallet, byggs om
 * varje ajaxCart.load()) till en egen .hsCartFooterWrap som ligger som
 * direkt barn i modalen, utanfor scroll-mittpartiet.
 *
 * beautify() byter texten "Totalt att betala" -> "Total"
 * (.headerCartTotalTitle - Shopifys cart.general.subtotal-lokalisering,
 * bakad i Handlebars-templaten, kan inte Liquid-andras har).
 *
 * applySalePricing() hamtar /cart.js + /products/{handle}.js per rad.
 * VIKTIGT: compare_at_price fran /products/{handle}.js ar redan i ore
 * (samma format som item.price fran /cart.js) - INGEN *100-konvertering.
 *
 * autoOpen() rullar ut panelen nar korgen gar fran TOM till att innehalla
 * nagot, sa kunden ser att varan hamnade ratt.
 */
(function () {
  'use strict';

  // KRITISK FIX: assets/vela_ajaxcart.js's buildCart() valjer mellan
  // #headerCartTemplate (all var styling: headerCartQty/hsQtyWrap,
  // headerCartRemoveBox, headerCartTotalTitle) och #CartTemplate (helt
  // ostylad legacy-markup: drawerProductQty > .velaQty, cartRemoveBox,
  // cartSubtotalHeading) baserat pa window.ajaxcart_type === 'modal'.
  // Den variabeln satts i snippets/vela-header-javascript.liquid fran
  // temainstallningen settings.ajax_cart_method - som INTE ar satt till
  // "modal" i temats anpassningspanel. Resultat: #CartTemplate har
  // renderats hela tiden (bekraftat via "Totalt att betala" istallet for
  // var beautify()-satta "Total", och den ostylade dubbelringade
  // qty-steppern som ingen CSS mot headerCartQty/hsQtyWrap kunde na
  // eftersom de klasserna aldrig existerade i den faktiska DOM:en).
  // Overridear variabeln har - kors vid skript-parse, garanterat innan
  // ajaxCart.load() nagonsin anropas (vid klick), sa #headerCartTemplate
  // alltid anvands oavsett temainstallning.
  window.ajaxcart_type = 'modal';

  var modal, backdrop;
  var productCache = {};
  var lastCount = null;

  function els() {
    modal = document.getElementById('hsDesktopCartModal');
    backdrop = document.getElementById('hsCartDrawerBackdrop');
  }

  function beautify(modalEl) {
    modalEl.querySelectorAll('.headerCartTotalTitle').forEach(function (el) {
      if (el.textContent !== 'Total') el.textContent = 'Total';
    });
  }

  function restructure(modalEl) {
    if (!modalEl || modalEl.dataset.hsRestructured) return;

    var bar = modalEl.querySelector('.hemsyd-cart-fullscreen-bar');
    var shipping = modalEl.querySelector('.hemsyd-shipping-bar');
    var cartContainer = modalEl.querySelector('#cartContainer');
    var recommend = modalEl.querySelector('.hemsyd-cart-recommend');
    if (!bar || !cartContainer) return;

    modalEl.dataset.hsRestructured = '1';

    var headerWrap = document.createElement('div');
    headerWrap.className = 'hsCartHeaderWrap';
    headerWrap.appendChild(bar);
    if (shipping) headerWrap.appendChild(shipping);

    var middleWrap = document.createElement('div');
    middleWrap.className = 'hsCartMiddleWrap';
    middleWrap.appendChild(cartContainer);
    if (recommend) middleWrap.appendChild(recommend);

    modalEl.insertBefore(middleWrap, modalEl.firstChild);
    modalEl.insertBefore(headerWrap, modalEl.firstChild);
  }

  function wrapFooter(modalEl) {
    /* Sok BARA i det nyrenderade #cartContainer-innehallet - den GAMLA totalen
       ligger redan flyttad i .hsCartFooterWrap och far inte tas for ny. */
    var source = modalEl.querySelector('#cartContainer') || modalEl;
    var total = source.querySelector('.headerCartTotal');
    var buttons = source.querySelector('.headerCartButton');
    var footerWrap = modalEl.querySelector(':scope > .hsCartFooterWrap');

    if (!total || !buttons) {
      /* Inget NYTT att flytta. Det har tva helt olika orsaker:
         1. Korgen ar TOM (mallen renderar .headerCartEmpty, ingen total) -
            da ska footern bort, annars star "Total 232 kr" kvar bredvid
            "Din varukorg ar tom!".
         2. Containern har inte byggts om sedan forra flytten - totalen ligger
            redan i footerWrap. Da ska footern LAMNAS IFRED. Tidigare togs den
            bort aven har, vilket raderade Total + "Till kassan" varje gang
            refreshAll rakade kora tva ganger utan rebuild emellan (t.ex.
            open()-timeouten efter afterCartLoad) - kunden kunde inte na
            kassan fran panelen alls. */
      var isEmpty = source.querySelector('.headerCartEmpty');
      if (isEmpty && footerWrap) footerWrap.remove();
      return;
    }

    if (!footerWrap) {
      footerWrap = document.createElement('div');
      footerWrap.className = 'hsCartFooterWrap';
      modalEl.appendChild(footerWrap);
    } else {
      // Rensa foregaende Total/knapp-par innan det nya flyttas in - annars
      // staplas ett nytt par pa varje ajaxCart.load() (varje tillagd produkt).
      footerWrap.innerHTML = '';
    }
    footerWrap.appendChild(total);
    footerWrap.appendChild(buttons);
  }

  function fetchProductCached(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  function applySalePricing(modalEl) {
    if (!window.HSFavShared) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cart.items.forEach(function (item, idx) {
          var line = idx + 1;
          var row = modalEl.querySelector('.ajaxCartRow[data-line="' + line + '"]');
          if (!row) return;
          var priceEl = row.querySelector('.headerCartPrice');
          if (!priceEl || priceEl.dataset.hsSaleDone) return;

          fetchProductCached(item.handle).then(function (product) {
            if (!product || priceEl.dataset.hsSaleDone) return;
            var variant = (product.variants || []).filter(function (v) {
              return v.id === item.variant_id;
            })[0];
            if (!variant || !variant.compare_at_price) return;

            var compareAt = variant.compare_at_price;
            if (compareAt <= item.price) return;

            var lineCurrent = item.price * item.quantity;
            var lineCompare = compareAt * item.quantity;

            priceEl.dataset.hsSaleDone = '1';
            priceEl.innerHTML =
              '<span class="hsCartSalePrice">' + window.HSFavShared.money(lineCurrent) + '</span>' +
              '<span class="hsCartSaleCompare">' + window.HSFavShared.money(lineCompare) + '</span>';
          });
        });
      });
  }

  function applyStockLimits(modalEl) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cart.items.forEach(function (item, idx) {
          var line = idx + 1;
          var row = modalEl.querySelector('.ajaxCartRow[data-line="' + line + '"]');
          if (!row) return;
          var plusBtn = row.querySelector('.velaQtyPlus');
          if (!plusBtn) return;

          fetchProductCached(item.handle).then(function (product) {
            if (!product) return;
            var variant = (product.variants || []).filter(function (v) {
              return v.id === item.variant_id;
            })[0];
            if (!variant) return;

            // Shopify doljer exakt lagersaldo om inventory_policy ar "continue"
            // (obegransat trots inventory_quantity <= 0) - bara sparra nar
            // Shopify faktiskt hanterar lagret OCH policyn ar "deny".
            var managed = variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny';
            var atLimit = managed
              && typeof variant.inventory_quantity === 'number'
              && item.quantity >= variant.inventory_quantity;

            plusBtn.disabled = atLimit;
            plusBtn.classList.toggle('is-disabled', atLimit);
          });
        });
      });
  }

  function refreshModal(modalEl) {
    restructure(modalEl);
    wrapFooter(modalEl);
    beautify(modalEl);
    applySalePricing(modalEl);
    applyStockLimits(modalEl);
  }

  function refreshAll() {
    document.querySelectorAll('.velaAjaxCartModal').forEach(refreshModal);
  }

  /**
   * Rullar ut panelen nar korgen gar fran TOM till att innehalla nagot, sa
   * kunden ser att varan hamnade ratt.
   *
   * ENDAST forsta varan - medvetet. Oppnas panelen vid VARJE tillagg lagger
   * sig backdropen over sidan, och nasta klick pa en produkts Kop-knapp
   * stanger bara panelen i stallet for att lagga i varan. Det gor det
   * segare att handla flera saker, vilket ar precis tvartemot vad imao
   * 5+1-erbjudandet vill uppna.
   *
   * Startvardet lases fran antalsbubblan i headern (server-renderad av
   * Liquid) - annars hade forsta tillagget efter sidladdning missats.
   *
   * Bara desktop: under 1200px ar #hsDesktopCartModal dold via CSS och
   * mobilens varukorgsknapp navigerar i stallet till /cart, sa ett open()
   * dar hade last sidans scroll utan att visa nagot. Och pa /cart-sidan
   * sjalv finns inget att rulla ut.
   */
  function autoOpen(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    var prev = lastCount;
    lastCount = cart.item_count;
    if (prev === null) return;
    if (prev !== 0 || cart.item_count === 0) return;
    if (window.innerWidth < 1200) return;
    if (document.body.classList.contains('template-cart')) return;
    if (modal && modal.classList.contains('is-open')) return;
    open();
  }

  function open() {
    if (!modal) els();
    if (!modal) return;

    if (window.HSFavoritesDrawer) window.HSFavoritesDrawer.close();

    if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
      window.ajaxCart.load();
    }

    modal.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-open');
    document.documentElement.classList.add('hsFavDrawerOpen');
    document.body.classList.add('hsFavDrawerOpen');

    setTimeout(refreshAll, 300);
  }

  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-open');
    document.documentElement.classList.remove('hsFavDrawerOpen');
    document.body.classList.remove('hsFavDrawerOpen');
  }

  document.addEventListener('DOMContentLoaded', function () {
    els();
    if (backdrop) backdrop.addEventListener('click', close);

    var closeBtn = document.getElementById('hsDesktopCartClose');
    if (closeBtn) closeBtn.addEventListener('click', close);

    var badge = document.querySelector('.hsCartBadge');
    lastCount = badge ? (parseInt(badge.textContent, 10) || 0) : 0;

    document.querySelectorAll('[data-hs-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });

    if (window.jQuery) {
      window.jQuery('body').on('ajaxCart.afterCartLoad', function (_e, cart) {
        refreshAll();
        autoOpen(cart);
      });
    }
  });

  window.HSCartDrawer = { open: open, close: close };
})();
